export default {
	name: "name",
	url: "url",
	description: "description",
	author: "author",
	authors: "authors",
	authorEmail: "authorEmail",
	version: "version",
	bugs: "bugs",
	"bugs.url": "bugsUrl",
	"bugs.email": "bugsEmail",
	license: "license",
	repository: "repository",
};
